
























import { Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';


@Component
export default class IvtIpIsDatacenter extends mixins<PlanLimitsMixin>(PlanLimitsMixin) {
  @Prop() conditions: any;
  value: string = 'IS_NOT_IP_DATACENTER';
  predicate: string = 'EQUALS';

  @Watch('conditions', {
    immediate: true
  })
  onConditionsChanged(value: any) {
    if(!value.ipDataCenter) {
      this.$set(this.conditions, 'ipDataCenter', {
        predicate: 'EQUALS',
        values: 'IS_NOT_IP_DATACENTER'
      });
    }
  }

  @Watch('value')
  onValueChanged(value: string) {
    this.$set(this.conditions.ipDataCenter, 'values', value);
  }

  @Watch('predicate')
  onPredicateChanged(value: string) {
    this.$set(this.conditions.ipDataCenter, 'predicate', value);
  }

  mounted() {
    this.value = this.conditions.ipDataCenter.values;
  }

}
